export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构',
        },
        {
            prop: 'carType',
            label: '车型',
        },
        {
            prop: 'discount',
            label: '政策（%）',
        },
        {
            prop: 'handle',
            label: '操作',
        }
    ]
}

export default {}